define([
	"./_TextAlign",
	"./PluginFactory"
], function(_TextAlign,PluginFactory) {

	return PluginFactory.declare(_TextAlign, {
		"class": "csi-button-toggle csi-toggle-group-last",
		cssValue: "right",
		materialIcon: "format_align_right",
		pluginName: "textRight",
		title: "CanvasRightAlignText"
	});
});
